import { useEffect, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from '../../components/panel/panel.jsx';
import Select from 'react-select';
import axios from 'axios'
import Pagination from '../../components/pagination/pagination.jsx';
import moment from 'moment/moment.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { isEmpty } from '../../helper/helper.js';
import { toast } from 'react-toastify';


function ShipmentBulkyUpload() {

  const [dataTable, setDataTable] = useState([])
  const [dataUpload, setDataUpload] = useState([])
  const [state, setState] = useState({
    uploadFromDate: moment().format('YYYY-MM-DD'),
    uploadToDate: moment().format('YYYY-MM-DD'),
  });
  const [formData, setFormData] = useState({ currentPage: 1, rowsPerPage: 50 });
  const [activeTab, setActiveTab] = useState(0)
  const [fileUpload, setFileUpload] = useState(null);

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  function handleFileChange(event) {
    setFileUpload(event.target.files[0]);
    setDataUpload([])
  }

  const handleOnChangeSelect = (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        [e.name]: option.value,
      }))
    } else if (e.action === "clear") {
      setState(prevState => ({
        ...prevState,
        [e.name]: '',
      }))
    }
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const searchForm = async () => {

    setActiveTab(0)
    await refreshTable(1)
  }


  const refreshTable = useCallback(async (_page = formData.currentPage, _size = formData.rowsPerPage) => {
    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      uploadFromDate: state.uploadFromDate ?? '',
      uploadToDate: state.uploadToDate ?? '',
      batch: state.batchProcess ?? '',
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }

    setFormData(prevState => ({
      ...prevState,
      currentPage: _page ?? 1
    }))

    await axios.get(`${window.API_HOST}/v1/shipment-upload`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }, [formData, state])

  const uploadBulky = async () => {

    if (!state.accountCode) {
      toast.error('Please Chose Accountx')
      return;
    }

    if (!fileUpload) {
      toast.error('Please Chose File')
      return;
    }
    const formData = new FormData();
    formData.append('fileUpload', fileUpload);
    formData.append('accountCode', state.accountCode)

    await axios.post(`${window.API_HOST}/v1/shipment-upload`, formData)
      .then(async (res) => {
        const resp = res.data

        setDataUpload(resp.data)
        setActiveTab(1)

      }).catch(err => {
        toast.error(err.response.data.error)
      })

  }

  useEffect(() => {

    const fetchForm = async () => {
      setState(prevState => ({
        ...prevState,
      }))
      await axios.get(`${window.API_HOST}/v1/shipment-upload/form`)
        .then(res => {
          const resp = res.data;
          setFormData(prevState => ({
            ...prevState,
            mAccounts: resp.data.account ?? []
          }))

        }).catch(err => {

        })
    }

    const asyncRefrestTable = async () => {
      await refreshTable(1)
    }

    fetchForm()
    asyncRefrestTable()
    // eslint-disable-next-line
  }, [dataUpload])


  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Shipments Bulky <small>Upload Bulky Shipment</small></h1>
      <Panel>
        <PanelHeader noButton>Bulky Upload</PanelHeader>
        <PanelBody>
          <div className="row" >
            <div className='col-sm-4'>
              <div className="form-group row mb-0">
                <label className="col-sm-3 col-form-label text-left">Upload Date</label>
                <div className="col-sm-4 ">
                  <input className="form-control form-control-sm" type="date" name="uploadFromDate" onChange={handleOnChangeInputText} value={state.uploadFromDate ?? ""} />
                </div>
                <label className="col-sm-1 col-form-label text-center"> <span>to</span></label>
                <div className="col-sm-4">
                  <input className="form-control form-control-sm" type="date" name="uploadToDate" onChange={handleOnChangeInputText} value={state.uploadToDate ?? ""} />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Batch Process</label>
                <div className="col-sm-9">
                  <input className="form-control form-control-sm" type="text" name="batchProcess" onChange={handleOnChangeInputText} value={state.batchProcess ?? ""} placeholder='Batch Processing' />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                </div>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className="form-group row mb-2">
                <label className="col-sm-3 col-form-label text-left">Account</label>
                <div className="col-sm-9">
                  <Select name="accountCode" placeholder={"Account"}
                    value={(formData.mAccounts ?? []).find(({ value }) => { return value === state.accountCode }) ?? ""}
                    options={formData.mAccounts ?? []}
                    onChange={handleOnChangeSelect}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">File</label>
                <div className="col-sm-9">
                  <input type="file" id='fileUpload' name="fileUpload" onChange={handleFileChange} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={uploadBulky}><span className="fa fa-sm fa-upload"></span> Upload</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-12'>
              <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
                <TabList>
                  <Tab>History</Tab>
                  <Tab>Success ({dataUpload.filter((item) => { return item.success }).length ?? 0}) <i className="fa fa-circle-check text-success"></i></Tab>
                  <Tab><span className='text-red'>Failed ({dataUpload.filter((item) => { return item.success === false }).length ?? 0})</span> <i className="fa fa-circle-xmark text-red"></i></Tab>
                </TabList>
                <TabPanel>
                  <Panel>
                    <PanelBody>
                      <div className="table table-hover mb-0 text-dark">
                        <table className="table table-sm table-hover table-striped mb-0 text-dark">
                          <thead className='bg-lime-400 fw-bold'>
                            <tr>
                              <th>No.</th>
                              <th>Upload Type</th>
                              <th className='w-120px'>Upload Date</th>
                              <th>FileName</th>
                              <th>Batch</th>
                              <th>Upload By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(dataTable ?? []).map((val, key) => {
                              return (
                                <tr className='fs-8 fw-light' key={key}>
                                  <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                                  <td>{val.upload_type}</td>
                                  <td>{moment(val.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                                  <td>{val.original_filename}</td>
                                  <td>{val.batch}</td>
                                  <td>{val.updated_by}</td>
                                </tr>)
                            })}
                          </tbody>
                          <tfoot>

                          </tfoot>
                        </table>
                      </div>
                    </PanelBody>
                    <PanelFooter>
                      <div className='row'>
                        <div className="col-sm-12">
                          <Pagination
                            currentPage={formData.currentPage ?? 1}
                            totalRows={formData.totalRows ?? 1}
                            pageSize={formData.rowsPerPage ?? 50}
                            onPageChange={onChangePageHandler}
                            selectedPageHandler={onChangePageSelectHandler}
                          />
                        </div>
                      </div>
                    </PanelFooter>
                  </Panel>
                </TabPanel>
                <TabPanel>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <table className="table table-sm table-hover table-striped mb-0 text-dark">
                        <thead className='bg-lime-400 fw-bold'>
                          <tr>
                            <th>No.</th>
                            <th>Account</th>
                            <th>Shipment No</th>
                            <th>Internal Tracking No</th>
                            <th>Shipper Name</th>
                            <th>Consignee Name</th>
                            <th>Consignee Destination</th>
                            <th>Courier</th>
                            <th>Service Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(dataUpload.filter((item) => { return item.success === true }) ?? []).map((val, key) => {
                            return (
                              <tr className='fs-8 fw-light' key={key}>
                                <td>{(key + 1)}.</td>
                                <td>{val.account}</td>
                                <td>{val.shipment_no}</td>
                                <td>{val.internal_tracking_no}</td>
                                <td>{val.shipper_name}</td>
                                <td>{val.consignee}</td>
                                <td>{val.receiver_city} - {val.receiver_district}</td>
                                <td>{val.courier_code}</td>
                                <td>{val.service_type}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <table className="table table-sm table-hover table-striped mb-0 text-dark">
                        <thead className='bg-lime-400 fw-bold'>
                          <tr>
                            <th>No.</th>
                            <th>Account</th>
                            <th>Shipment No</th>
                            <th>Shipper Name</th>
                            <th>Consignee Name</th>
                            <th>Consignee Destination</th>
                            <th>Courier</th>
                            <th>Service Type</th>
                            <th>Error</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(dataUpload.filter((item) => { return item.success === false }) ?? []).map((val, key) => {
                            return (
                              <tr className='fs-8 fw-light' key={key}>
                                <td>{(key + 1)}.</td>
                                <td>{val.account}</td>
                                <td>{val.shipment_no}</td>
                                <td>{val.shipper_name}</td>
                                <td>{val.consignee}</td>
                                <td>{val.receiver_city} - {val.receiver_district}</td>
                                <td>{val.courier_code}</td>
                                <td>{val.service_type}</td>
                                <td><strong className='text-danger'>{val.error}</strong></td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </PanelBody>
      </Panel>

    </div>
  )
}

export default ShipmentBulkyUpload;